export const generateClickDate = () => {
  const now = new Date(Date.now())
  const year = now.getFullYear()
  let month = (now.getMonth() + 1).toString()
  let day = now.getDate().toString()
  let hour = now.getHours().toString()
  let minute = now.getMinutes().toString()
  let second = now.getSeconds().toString()
  let ms = now.getMilliseconds().toString()

  month = month.length > 1 ? month : '0' + month
  day = day.length > 1 ? day : '0' + day
  hour = hour.length > 1 ? hour : '0' + hour
  minute = minute.length > 1 ? minute : '0' + minute
  second = second.length > 1 ? second : '0' + second
  ms = ms.length === 1 ? '0' + ms : ms
  ms = ms.length === 2 ? '0' + ms : ms

  return `${month}/${day}/${year} ${hour}:${minute}:${second}.${ms}`
}
